import React from "react";
import InDemandDataReport from "./inDemandDataReport";
import DownloadFiles from "./DownloadFiles";
import BackendReport from "./BackendReport";

export default function GenerateReports() {
  return (
    <div>
      <BackendReport />
      <InDemandDataReport />
      <DownloadFiles />
    </div>
  );
}
